import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit';
import { errorHandlerMiddleware } from './middlewares/error';
import { breadcrumbSlice, BreadcrumbState } from './slices/breadcrumb';
import { clientsSlice, ClientsState } from './slices/clients';
import { germinationRoomsSlice, GerminationRoomsState } from './slices/germinationRoom';
import { healingRoomsSlice, HealingRoomsState } from './slices/healingRoom';
import { notificationSlice, NotificationState } from './slices/notification';
import { productsSlice, ProductsState } from './slices/products';
import { sessionSlice, SessionState } from './slices/session';
import { usersSlice, UsersState } from './slices/users';
import { vehiclesSlice, VehiclesState } from './slices/vehicle';
import { greenhousesSlice, GreenhousesState } from './slices/greenhouse';
import { resourcesSlice, ResourcesState } from './slices/resource';
import { traysSlice, TraysState } from './slices/tray';
import { organizationsSlice, OrganizationsState } from './slices/organizations';
import { ordersSlice, OrdersState } from './slices/order';
import { orderItemsSlice, OrderItemsState } from './slices/orderItem';
import { productionItemsSlice, ProductionItemsState } from './slices/productionItem';

export type RootState = {
  session: SessionState
  notification: NotificationState
  breadcrumb: BreadcrumbState
  organizations: OrganizationsState
  users: UsersState
  clients: ClientsState
  products: ProductsState
  germinationRooms: GerminationRoomsState
  healingRooms: HealingRoomsState
  vehicles: VehiclesState
  greenhouses: GreenhousesState
  resources: ResourcesState
  trays: TraysState
  orders: OrdersState
  orderItems: OrderItemsState
  productionItems: ProductionItemsState
}

const baseReducer = combineReducers({
  session: sessionSlice.reducer,
  notification: notificationSlice.reducer,
  breadcrumb: breadcrumbSlice.reducer,
  organizations: organizationsSlice.reducer,
  users: usersSlice.reducer,
  clients: clientsSlice.reducer,
  products: productsSlice.reducer,
  germinationRooms: germinationRoomsSlice.reducer,
  healingRooms: healingRoomsSlice.reducer,
  vehicles: vehiclesSlice.reducer,
  greenhouses: greenhousesSlice.reducer,
  resources: resourcesSlice.reducer,
  trays: traysSlice.reducer,
  orders: ordersSlice.reducer,
  orderItems: orderItemsSlice.reducer,
  productionItems: productionItemsSlice.reducer,
});

const store = configureStore({
  reducer: baseReducer,
  middleware: getDefaultMiddleware().concat([
    errorHandlerMiddleware,
  ]),
});

export type AppDispatch = typeof store.dispatch;

export default store;
